import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    align-items: center;
`;

export const IconWrapper = styled.div`
    height: 24px;
    width: 24px;
    flex: 0 0 auto;
    margin-right: 12px;
    & > * {
        fill: ${({ theme }) => theme.colors.Foreground};
    }
`;

export const TextWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    ${({ theme }) => css(theme.typography.Paragraph)};
`;

export const ToolTipText = styled.div`
    ${({ theme }) => css(theme.typography.Paragraph)};
    color: ${({ theme }) => theme.colors.Foreground};
    margin-left: 4px;
    text-decoration: underline;
    cursor: help;
`;
